/**
 * Trade hashes whose limit order THIS tab cancelled.
 *
 * The backend publishes the `Cancelled` status to every tab, and a tab that did
 * not press the button has to say something ("Limit order cancelled") or the
 * order simply vanishes from the rail. The tab that DID press it already
 * reported the outcome, so it must not toast twice. Recording the hash on the
 * way out and consuming it when the push lands is the same trick
 * `pendingClosedTradeHash` plays for closes, kept module-scoped because the
 * cancel and the push are handled by two different hooks.
 *
 * Bounded: the set only ever holds hashes between a local cancel and its push
 * (or the eviction below), so an unpushed cancel cannot grow it without limit.
 */
const LOCAL_CANCELS = new Set<string>();

/** Hashes beyond this are dropped oldest-first — a push that never arrives must
 *  not pin an entry forever. Far above any realistic number in flight. */
const MAX_TRACKED = 32;

export function markLocalLimitCancel(tradeHash: string | null): void {
    if (!tradeHash) return;
    if (LOCAL_CANCELS.size >= MAX_TRACKED) {
        const oldest = LOCAL_CANCELS.values().next().value;
        if (oldest !== undefined) LOCAL_CANCELS.delete(oldest);
    }
    LOCAL_CANCELS.add(tradeHash);
}

/** True when this tab cancelled that order; clears the record either way. */
export function consumeLocalLimitCancel(tradeHash: string): boolean {
    return LOCAL_CANCELS.delete(tradeHash);
}

/** Test seam only. */
export function resetLocalLimitCancels(): void {
    LOCAL_CANCELS.clear();
}
